export default {
  strict: true,
  namespaced: true,
  state: {
    selectedDriver: null,
    onDuty: {
      list: [],
      loading: false,
      pageNum: 1,
      pageSize: 20,
      totalPages: 0,
      noDriversFound: false,
      order: 'ID',
      asc: true
    },
    sortTypeTNC: 'priority',
    sortTypeTCP: 'priority'
  },
  mutations: {
    setSelectedDriver (state, value) { state.selectedDriver = value },
    setOnDutyDrivers (state, drivers) { state.onDuty.drivers = drivers },
    setOnDutyLoading (state, value) { state.onDuty.loading = value },
    setOnDutyPageNumber (state, value) { state.onDuty.pageNum = value },
    setOnDutyTotalPages (state, total) { state.onDuty.totalPages = Math.ceil(total / state.onDuty.pageSize) },
    addToOnDutyDrivers (state, driver) { state.onDuty.drivers.unshift(driver) },
    setOnDutyNoDriversFound (state, value) { state.onDuty.noDriversFound = value },
    setOnDutySorting (state, value) {
      state.onDuty.order = value.order
      state.onDuty.asc = value.asc
    },
    removeFromOnDutyDrivers (state, driverId) {
      if (state.onDuty.drivers.length <= 0) {
        state.onDuty.pageNum = 1
        state.onDuty.totalPages = 0
        return
      }
      let drivers = state.onDuty.drivers
      state.onDuty.drivers = drivers.filter(driver => driver.id !== driverId)
      if (state.onDuty.drivers.length <= 0) {
        state.onDuty.pageNum = 1
        state.onDuty.totalPages = 0
      }
    },
    setTNCSortType (state, value) { state.sortTypeTNC = value},
    setTCPSortType (state, value) { state.sortTypeTCP = value},
  }
};



// WEBPACK FOOTER //
// ./src/store/laxit/drivers.js